import Input from "../../components/Input/Input";
import Select from "../../components/Select/Select";
import SearchableSelect from "../../components/Select/SearchableSelect";
import Button from "../../components/Button/Button";
import { SORT_ORDER_OPTIONS, STATUS_FILTER_OPTIONS } from "./LessonPlannerConstant";

const AllLessonPlansFilter = ({
  filters,
  teacherOptions,
  programOptions,
  subjectOptions,
  onFilterChange,
  onSearch,
  onReset,
}) => (
  <div className="row mb-3">
    <div className="col-md-4">
      <Input
        name="search"
        placeholder="Search lesson title"
        value={filters.search}
        onChangeHandler={onFilterChange}
        onKeyDown={(event) => event.key === "Enter" && onSearch()}
      />
    </div>

    <div className="col-md-4 mb-3">
      <SearchableSelect
        name="teacher_id"
        placeholder="Select Teacher"
        value={filters.teacher_id}
        options={teacherOptions}
        onChangeHandler={onFilterChange}
      />
    </div>

    <div className="col-md-4 mb-3">
      <Select
        name="status"
        placeholder="All Status"
        value={filters.status}
        options={STATUS_FILTER_OPTIONS}
        onChangeHandler={onFilterChange}
      />
    </div>

    <div className="col-md-4 mb-3">
      <SearchableSelect
        name="program_id"
        placeholder="Select Class"
        value={filters.program_id}
        options={programOptions}
        onChangeHandler={onFilterChange}
      />
    </div>

    <div className="col-md-4 mb-3">
      <Select
        name="subject_id"
        placeholder={filters.program_id ? "Select Subject" : "Select a class first"}
        value={filters.subject_id}
        options={subjectOptions}
        onChangeHandler={onFilterChange}
        disabled={!filters.program_id}
      />
    </div>

    <div className="col-md-4 mb-3">
      <Select
        name="sort_order"
        placeholder="Sort by"
        value={filters.sort_order}
        options={SORT_ORDER_OPTIONS}
        onChangeHandler={onFilterChange}
      />
    </div>

    <div className="col-md-4">
      <Input
        type="date"
        name="lesson_date_from"
        label="Lesson date from"
        value={filters.lesson_date_from}
        max={filters.lesson_date_to || undefined}
        onChangeHandler={onFilterChange}
      />
    </div>

    <div className="col-md-4">
      <Input
        type="date"
        name="lesson_date_to"
        label="Lesson date to"
        value={filters.lesson_date_to}
        min={filters.lesson_date_from || undefined}
        onChangeHandler={onFilterChange}
      />
    </div>

    <div className="col-md-4 d-flex align-items-end mb-3">
      <Button variant="success" onClick={onSearch}>
        Search
      </Button>
      <Button variant="secondary" onClick={onReset} className="mx-2">
        Reset
      </Button>
    </div>
  </div>
);

export default AllLessonPlansFilter;
